import axios from "axios";
import config from "./config";

export const login = (body) => {
  return axios.post("/authenticate", body, config);
}
